var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFluentLocation24Filled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8566 25.7839L26.0761 27.5449C24.7636 28.8319 23.0611 30.4879 20.9671 32.5129C20.3377 33.1214 19.4965 33.4616 18.6211 33.4616C17.7456 33.4616 16.9044 33.1214 16.2751 32.5129L11.0386 27.4189C10.3786 26.7724 9.82955 26.2279 9.38555 25.7839C7.5591 23.9573 6.3153 21.6301 5.81144 19.0967C5.30757 16.5632 5.56627 13.9372 6.55481 11.5508C7.54336 9.16433 9.21736 7.12462 11.3651 5.68955C13.5129 4.25449 16.038 3.48853 18.6211 3.48853C21.2041 3.48853 23.7292 4.25449 25.877 5.68955C28.0247 7.12462 29.6987 9.16433 30.6873 11.5508C31.6758 13.9372 31.9345 16.5632 31.4307 19.0967C30.9268 21.6301 29.683 23.9573 27.8566 25.7839ZM22.3711 16.9609C22.3711 15.9663 21.976 15.0125 21.2727 14.3092C20.5694 13.6059 19.6156 13.2109 18.6211 13.2109C17.6265 13.2109 16.6727 13.6059 15.9694 14.3092C15.2661 15.0125 14.8711 15.9663 14.8711 16.9609C14.8711 17.9554 15.2661 18.9093 15.9694 19.6125C16.6727 20.3158 17.6265 20.7109 18.6211 20.7109C19.6156 20.7109 20.5694 20.3158 21.2727 19.6125C21.976 18.9093 22.3711 17.9554 22.3711 16.9609Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentLocation24Filled);
export default __webpack_public_path__ + "static/media/fluent_location-24-filled.2ac9de9333d0a7df9ac198056b5a859d.svg";
export { ForwardRef as ReactComponent };